import { Link } from "react-router-dom";
import { ArrowRight, MapPin } from "lucide-react";

export const Hero = () => {
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-[90vh] flex items-center pt-20 overflow-hidden bg-[#050505]"
    >
      {/* Background grid */}
      <div className="absolute inset-0 bh-grid-bg opacity-30" />
      <div
        className="absolute -left-40 top-1/4 w-[500px] h-[500px] rounded-full blur-3xl"
        style={{ background: "rgba(37, 99, 235, 0.10)" }}
      />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center py-12">
        {/* LEFT */}
        <div className="bh-fade-up">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 border border-white/10 bg-white/[0.02] text-xs tracking-[0.2em] uppercase text-[#60A5FA]">
            <span className="w-1.5 h-1.5 bg-[#60A5FA] rounded-full" />
            The Foundation For Success
          </div>

          <h1 className="font-display mt-6 text-5xl sm:text-6xl lg:text-7xl xl:text-8xl font-bold tracking-tight uppercase leading-[0.95]">
            Build Elite
            <br />
            <span className="text-[#2563EB]">Performance</span>
          </h1>

          <p
            data-testid="hero-description"
            className="mt-8 text-[#A1A1AA] text-base md:text-lg leading-relaxed max-w-xl"
          >
            BlueprintHoopz develops basketball athletes through elite-level
            skill training, athletic performance, confidence building, and
            modern player development.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <Link
              to="/book"
              data-testid="hero-start-training-btn"
              className="group inline-flex items-center justify-center gap-2 bg-[#2563EB] hover:bg-[#1D4ED8] text-white font-bold tracking-widest uppercase text-sm px-8 py-4 rounded-sm transition-colors"
            >
              Start Training
              <ArrowRight
                size={16}
                className="transition-transform group-hover:translate-x-1"
              />
            </Link>
            <a
              href="#memberships"
              data-testid="hero-view-programs-btn"
              className="inline-flex items-center justify-center gap-2 border border-white/20 hover:border-[#2563EB] hover:text-[#60A5FA] text-white font-bold tracking-widest uppercase text-sm px-8 py-4 rounded-sm transition-colors"
            >
              View Pricing
            </a>
          </div>

          <div className="mt-12 flex items-center gap-6 text-[#A1A1AA] text-xs tracking-widest uppercase">
            <div className="flex items-center gap-2">
              <MapPin size={14} className="text-[#60A5FA]" /> Greenville / Taylors, SC
            </div>
            <div className="h-3 w-px bg-white/10" />
            <div>Mon – Fri · 12 PM – 5 PM</div>
          </div>
        </div>

        {/* RIGHT - Athlete image */}
        <div className="relative bh-fade-up" style={{ animationDelay: "0.15s" }}>
          <div className="relative aspect-square max-h-[680px] w-full mx-auto overflow-hidden">
            <div className="absolute inset-0 bg-[#070B14]" />
            <img
              src="https://images.pexels.com/photos/30050101/pexels-photo-30050101.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900"
              alt="BlueprintHoopz athlete on the court"
              className="absolute inset-0 w-full h-full object-cover object-center"
              data-testid="hero-athlete-image"
            />
            {/* Dark overlay for cinematic depth */}
            <div className="absolute inset-0 bg-gradient-to-tr from-[#050505]/70 via-[#050505]/10 to-transparent" />
            <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#050505]/60" />

            {/* Floating top-left badge */}
            <div className="absolute left-4 top-4 md:left-6 md:top-6 backdrop-blur-md bg-[#070B14]/80 border border-white/10 px-4 py-3">
              <div className="text-[10px] tracking-[0.25em] text-white/60 uppercase">
                Elite Track
              </div>
              <div className="text-white font-display text-base font-semibold mt-1">
                Player Development
              </div>
            </div>

            {/* Floating bottom-left stat card (kept away from the ball) */}
            <div className="absolute left-4 bottom-4 md:left-6 md:bottom-6 backdrop-blur-md bg-[#070B14]/80 border border-white/10 px-5 py-4">
              <div className="text-[#60A5FA] font-display text-3xl font-bold">
                100%
              </div>
              <div className="text-[10px] tracking-[0.25em] text-white/70 uppercase">
                Player Focused
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
